import http from "@/utils/http";


export const DashboardApi = {
    //获取简单列表（全部规则）
    queryDashboardBarOption(query) {
        return http.get(`/nexus/dashboard/queryDashboardBarOption`,query)
    },
    queryDashboardPieOption(query) {
        return http.get(`/nexus/dashboard/queryDashboardPieOption`,query)
    },
}